import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import MetaQueryForm from 'Components/UI/Meta/MetaQueryForm';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    marginTop: theme.spacing(1),
  },
  row: {
    flex: 1,
  },
  rowItem: {
    marginTop: theme.spacing(1),
  },
  filterActions: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
  },
  filterAction: {
    margin: theme.spacing(1),
  },
  refreshButton: {
    marginTop: theme.spacing(2),
  },
  refreshIcon: {
    fontSize: theme.typography.h4.fontSize,
    marginRight: theme.spacing(1),
  },
});

const View = ({
  classes,
  onApplyFilters,
  collection,
  availableFilters,
  defaultFilters,
  amplitudeRootNodeProps,
}) => {
  return (
    <Box className={classes.root} {...amplitudeRootNodeProps}>
      <Box className={classes.row} debugColor="dodgerBlue">
        {collection && (
          <MetaQueryForm
            collection={collection}
            onSubmit={onApplyFilters}
            availableFilters={availableFilters}
            defaultFilters={defaultFilters}
          />
        )}
      </Box>
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object.isRequired,
  onApplyFilters: PropTypes.func.isRequired,
  collection: PropTypes.object.isRequired,
  availableFilters: PropTypes.array.isRequired,
  defaultFilters: PropTypes.object.isRequired,
  amplitudeRootNodeProps: PropTypes.object.isRequired,
};
View.defaultProps = {
};
export default withStyles(styles)(View);
